export default __webpack_public_path__ + "static/media/settings.f24a0dda.gif";